var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content is-small uploaded-file-link"},[(_vm.filename !== '')?_c('a',{attrs:{"href":'https://api-rfi.tianenusa.com/files/' + _vm.filename,"target":"_blank"}},[_vm._v("https://api-rfi.tianenusa.com/files/"+_vm._s(_vm.filename))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-202d7abd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UploadedFile.vue
// module id = null
// module chunks = 